module.exports = __webpack_public_path__ + "img/payBannerBlue.fbb25f27.jpg";